export default "__VITE_ASSET__8vYUIVVt__"